import { formatRoleLabel } from "./roleDisplay";

// Resolves a role_id against the loaded roles list. Returns a display-ready
// object rather than throwing, since role resolution can legitimately fail
// (deleted/renamed role) and the UI must show a warning state, not crash.
export const resolveAssignmentRole = (assignment, rolesById) => {
  const role = rolesById?.get(assignment.role_id);
  if (!role) {
    return { role: null, label: "Unknown role", isUnknown: true };
  }
  return { role, label: formatRoleLabel(role.role_name), isUnknown: false };
};

export const buildRolesById = (roles) => {
  const map = new Map();
  (roles || []).forEach((role) => map.set(role.id, role));
  return map;
};

// Assignee display: email > user ID for users; app ID > generic label for apps.
export const getAssigneeDisplay = (assignment) => {
  if (assignment.is_app) {
    return {
      primary: assignment.app_id || "Application",
      secondary: assignment.app_id ? "Application" : null,
    };
  }
  return {
    primary: assignment.email || assignment.user_id || "Unknown user",
    secondary: assignment.email && assignment.user_id ? assignment.user_id : null,
  };
};

export const getAssignmentTypeLabel = (assignment) => (assignment.is_app ? "Application" : "User");

// User assignments don't always carry org_id directly (access can be derived
// from org ownership) — the table must not fabricate an org name in that case.
// orgsById (Map of org _id -> org record, from GET /organizations) resolves
// the id to its display name; falls back to the raw id if the org isn't
// found (e.g. deleted/inactive org not in the active-orgs list).
export const getOrganizationDisplay = (assignment, orgsById) => {
  // org_id is a string on older records and a list on assignments that cover
  // several organizations — show every org's name, in order, for a list.
  const orgIds = Array.isArray(assignment.org_id) ? assignment.org_id.filter(Boolean) : assignment.org_id ? [assignment.org_id] : [];
  if (orgIds.length > 0) {
    return { label: orgIds.map((id) => orgsById?.get(id)?.name || id).join(", "), isDerived: false };
  }
  if (!assignment.is_app) return { label: "Organization access derived", isDerived: true };
  return { label: "—", isDerived: false };
};

export const buildOrgsById = (orgs) => {
  const map = new Map();
  (orgs || []).forEach((org) => map.set(org._id, org));
  return map;
};
